export const STORE_MODULE_APPLICATION_GETTER_GET_CURRENT_APPLICATION =
  'getCurrentApplication';
